import React from 'react';
import { Box, Typography } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

const LINKS = [
  { label: 'Оферта',                      to: '/agb' },
  { label: 'Политика конфиденциальности',  to: '/gdpr' },
  { label: 'Импрессум',                    to: '/impressum' },
  { label: 'Контакты',                     to: '/contacts' },
];

export default function Footer() {
  return (
    <Box
      component="footer"
      sx={{
        mt: 'auto',
        py: 2,
        px: 3,
        borderTop: '1px solid',
        borderColor: 'divider',
        display: 'flex',
        flexWrap: 'wrap',
        gap: 2,
        justifyContent: 'center',
      }}
    >
      {LINKS.map(({ label, to }) => (
        <Typography
          key={to}
          variant="body2"
          color="text.secondary"
          component={RouterLink}
          to={to}
          sx={{ textDecoration: 'none', '&:hover': { textDecoration: 'underline' }, color: 'inherit' }}
        >
          {label}
        </Typography>
      ))}
    </Box>
  );
}
